import React from 'react';
import Preview from 'components/commercetools-ui/organisms/checkout/components/steps/previews/wrapper';
import { useFormat } from 'helpers/hooks/useFormat';
import { AmazonReviewData } from '../../types/AmazonReviewData';
import { amazonSessionAddress } from '../../types/amazonSessionAddress';

export interface Props {
  amazonpayReviewData?: AmazonReviewData;
}

const AmazonpayAddressesPreview: React.FC<Props> = ({ amazonpayReviewData }) => {
  const shippingAddress: amazonSessionAddress = amazonpayReviewData?.shippingAddress ?? {};
  const billingAddress: amazonSessionAddress = amazonpayReviewData?.billingAddress ?? {};
  const { formatMessage: formatCheckoutMessage } = useFormat({ name: 'checkout' });

  const addressPart = (...parts: (string | undefined)[]): string => parts.filter(Boolean).join(', ');

  const AddressDisplay = (address: amazonSessionAddress) => {
    const addressLine1 = address.firstName;
    const addressLine2 = addressPart(address.streetNumber, address.streetName, address.county);
    const addressLine3 = addressPart(address.postalCode, address.city, address.country);

    return (
      <p className="text-14 font-light leading-5 text-secondary-black">
        {addressLine1 && (
          <>
            {addressLine1}
            <br />
          </>
        )}
        {addressLine2 && (
          <>
            {addressLine2}
            <br />
          </>
        )}
        {(address.postalCode || address.city) && <>{addressLine3}</>}
      </p>
    );
  };

  return (
    <Preview>
      <div className="border-neutral-400 lg:border lg:p-16">
        <div className="border-l-4 border-ag_color-text_green py-18 pl-18">
          <div className="block gap-10 md:flex">
            <div className="w-full md:w-[40%]">
              <div className="mb-12 text-14 font-medium">
                {formatCheckoutMessage({
                  id: 'shippingAddress',
                  defaultMessage: 'Shipping Address',
                })}
              </div>
              {AddressDisplay(shippingAddress)}
            </div>
            <div className="mt-30 w-full md:mt-auto md:w-[40%]">
              <div className="mb-12 text-14 font-medium">
                {formatCheckoutMessage({
                  id: 'billingAddress',
                  defaultMessage: 'Billing Address',
                })}
              </div>
              {AddressDisplay(billingAddress)}
            </div>
          </div>
          {}
        </div>
      </div>
    </Preview>
  );
};

export default AmazonpayAddressesPreview;
